import { useBookingModuleStore, useCalendarRoot } from "PFApp/booking/store";
import { ProjectsView } from "PFApp/booking/types";
import { CalendarRoot } from "PFApp/booking/types/calendar_root";
import { isProjects } from "PFApp/booking/utils/calendar_root.utils";
import { useIsCurrentUserPermittedTo } from "PFCore/helpers/use_is_permitted_to";
import { PermissionRule } from "PFTypes";
import { useEffect } from "react";

export const useResetProjectsView = () => {
  const isGridViewEnabled = useIsCurrentUserPermittedTo(PermissionRule.GridView);

  const calendarRoot = useCalendarRoot();

  const projectsView = useBookingModuleStore((state) =>
    isProjects(calendarRoot) ? state[calendarRoot].view : null
  );

  const setViewEngagements = useBookingModuleStore(
    (state) => state.actions[CalendarRoot.ProjectsEngagements].setView
  );
  const setViewRoles = useBookingModuleStore((state) => state.actions[CalendarRoot.ProjectsRoles].setView);

  useEffect(() => {
    if (!isProjects(calendarRoot) || !projectsView) {
      return;
    }

    if (!isGridViewEnabled && projectsView === ProjectsView.Grid) {
      const setViewForCurrentRoot =
        calendarRoot === CalendarRoot.ProjectsEngagements ? setViewEngagements : setViewRoles;
      setViewForCurrentRoot(ProjectsView.Gantt);
    }
  }, [isGridViewEnabled, projectsView, calendarRoot, setViewEngagements, setViewRoles]);
};
